import { useState } from "react";
import Layout from "./../../components/common/layout";
import Steps from "./../../components/pages/imageIdentification/steps";
import UploadImageStep from "./../../components/pages/imageIdentification/uploadImageStep";
import IdentificationStep from "./../../components/pages/imageIdentification/identificationStep";
import ResultStep from "./../../components/pages/imageIdentification/resultStep";
import FeedbackStep from "./../../components/pages/imageIdentification/feedbackStep";
function ImageIdentification(props) {
  const [currentStep, setCurrentStep] = useState(1);

  const changeStepHandler = (stepState) => {
    setCurrentStep(stepState);
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  };

  return (
    <>
      <Layout withFixedItem={currentStep === 3 && true}>
        <section className="image__identification">
          <div className="wrapper">
            <div className="content">
              <Steps activeStep={currentStep} />
              {currentStep === 1 && (
                <UploadImageStep changeStep={changeStepHandler} />
              )}
              {currentStep === 2 && (
                <IdentificationStep changeStep={changeStepHandler} />
              )}
              {currentStep === 3 && (
                <ResultStep changeStep={changeStepHandler} />
              )}
              {currentStep === 4 && (
                <FeedbackStep changeStep={changeStepHandler} />
              )}
            </div>
          </div>
        </section>
      </Layout>
    </>
  );
}

export default ImageIdentification;
